import { render, staticRenderFns } from "./CheckboxArea.vue?vue&type=template&id=58a11c9a&scoped=true&"
import script from "./CheckboxArea.vue?vue&type=script&lang=js&"
export * from "./CheckboxArea.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxArea.vue?vue&type=style&index=0&id=58a11c9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a11c9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/uu264406/workDirectory/shingaku/reset_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a11c9a')) {
      api.createRecord('58a11c9a', component.options)
    } else {
      api.reload('58a11c9a', component.options)
    }
    module.hot.accept("./CheckboxArea.vue?vue&type=template&id=58a11c9a&scoped=true&", function () {
      api.rerender('58a11c9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/contents/components/pages/signIn/common/CheckboxArea.vue"
export default component.exports